import { z } from 'zod';

export const ApiKeyWindowSchema = z.enum(['7d', '30d', '90d', '1y', 'never']);
export type ApiKeyWindow = z.infer<typeof ApiKeyWindowSchema>;

export const ApiKeyCapabilitySchema = z.enum(['public', 'admin']);
export type ApiKeyCapability = z.infer<typeof ApiKeyCapabilitySchema>;

export const ApiKeyScopeSchema = z.enum([
  'automation:cli',
  'automation:full',
  'automation:extension',
  'automation:upload',
  'mobile:app',
  'admin:api',
]);
export type ApiKeyScope = z.infer<typeof ApiKeyScopeSchema>;

export const AccountApiKeyCreateBodySchema = z.object({
  label: z.string().optional(),
  description: z.string().optional(),
  expiresIn: ApiKeyWindowSchema.optional(),
  capability: ApiKeyCapabilitySchema.optional(),
  scopes: z.array(ApiKeyScopeSchema).optional(),
  ownerUserId: z.string().optional(),
});

export const AccountApiKeyResponseSchema = z.object({
  apiKey: z.string(),
  token: z.string(),
  expiresAt: z.date().nullable(),
  id: z.string(),
  capability: ApiKeyCapabilitySchema,
  scopes: z.array(ApiKeyScopeSchema),
  user: z.object({
    id: z.string(),
    email: z.string().nullable(),
    username: z.string().nullable(),
    handle: z.string().nullable(),
    displayName: z.string(),
  }),
});

export const AccountApiKeysListResponseSchema = z.object({
  keys: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      description: z.string().nullable(),
      capability: ApiKeyCapabilitySchema,
      scopes: z.array(ApiKeyScopeSchema),
      createdAt: z.date(),
      expiresAt: z.date().nullable(),
      lastUsedAt: z.date().nullable(),
      createdByUserId: z.string().nullable(),
    })
  ),
});

export const AccountApiKeyDeleteResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

export const AccountDeleteResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

export type AccountApiKeysListResponse = z.infer<typeof AccountApiKeysListResponseSchema>;
